import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Para qué edades es el sistema?',
  a: 'El Método Conecta-TEA está optimizado para niños con TEA de 3 a 12 años con comunicación verbal limitada o no verbal. Algunas secciones son adaptables para adolescentes con TEA.'
}, {
  q: '¿Necesito ser terapeuta para usarlo?',
  a: 'No. El sistema fue diseñado específicamente para padres sin formación terapéutica. Cada herramienta tiene instrucciones claras y visuales. Si podés imprimir y seguir pasos, podés usar esto.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Es un producto 100% digital. Después de la compra recibís un email con acceso inmediato a todos los PDF. Los descargás y los imprimís en casa o en una fotocopiadora.'
}, {
  q: '¿Puedo imprimirlo?',
  a: 'Sí. Todos los materiales están diseñados para impresión en A4. El costo de impresión completa ronda los $3.000 a $5.000 en una fotocopiadora del barrio.'
}, {
  q: '¿Cuánto tiempo necesito dedicarle por día?',
  a: 'Con 15 minutos diarios el sistema funciona. Está diseñado para padres con poco tiempo y mucho amor.'
}, {
  q: '¿Cuál es la diferencia entre Plan Base y Plan Premium?',
  a: 'El Plan Base incluye los 5 Tomos + 5 Bonos (160 páginas). El Plan Premium suma el Protocolo de Paz, el manual de intervención avanzada para crisis y conductas desafiantes (45 páginas adicionales, 280 páginas totales).'
}, {
  q: '¿Funciona si mi hijo también tiene comunicación verbal?',
  a: 'Sí. Aunque está optimizado para comunicación limitada o no verbal, los pictogramas y rutinas visuales benefician a cualquier niño con TEA independientemente de su nivel verbal.'
}, {
  q: '¿Lo puedo usar junto con la terapia que ya hace mi hijo?',
  a: 'Absolutamente. Fue diseñado para complementar cualquier enfoque terapéutico. El Bono 4 (Manual Escolar) y el Bono 5 (Planner) están especialmente pensados para trabajar en coordinación con terapeutas y docentes.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-12 md:py-16 bg-white" data-id="element-75">
      <div className="container mx-auto px-4 max-w-2xl" data-id="element-76">
        <h2 className="text-2xl font-bold text-teal-900 text-center mb-8" data-id="element-77">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>
        <div className="space-y-3" data-id="element-78">
          {faqs.map((faq, i) => <div key={i} className="border-b border-stone-200" data-id="element-79">
              <button className="w-full py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-80">
                <span className="font-bold text-stone-700 text-sm" data-id="element-81">
                  {faq.q}
                </span>
                <ChevronDown className={`w-4 h-4 text-stone-400 transition-transform ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-82" />
              </button>
              <AnimatePresence data-id="element-83">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} data-id="element-84">
                    <div className="pb-4 text-sm text-stone-600" data-id="element-85">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}